import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
  name: "login",
  initialState: {
    user: "",
    isLoggedUserPass: false,
    isLoggedIn: false,
    infoUser: null,
    token: null,
    permUser: [],
  },
  reducers: {
    signIn: ( state, action ) => {
      const { token } = action.payload.dataUser;
      const { INFOUSER } = action.payload.dataUser;
      const { USRIDXXX } = action.payload.dataUser.INFOUSER;
      state.user = USRIDXXX.toString();
      state.infoUser = INFOUSER;
      state.permUser = INFOUSER.USERPERM;
      state.token = token;
      state.isLoggedIn = true;
    },
    hydrateUserData: (state, action) => {
      const { INFOUSER } = action.payload;
      state.infoUser = INFOUSER;
      state.permUser = INFOUSER?.USERPERM || [];
      if (INFOUSER?.USRIDXXX) {
        state.user = INFOUSER.USRIDXXX.toString();
      }
    },
    signOut: (state) => {
      state.user = "";
      state.infoUser = null;
      state.token = null;
      state.isLoggedIn = false;
      state.permUser = [];
    }
  }
});

export const {
  signIn,
  hydrateUserData,
  signOut,
} = loginSlice.actions;

export default loginSlice.reducer;

export const getisLoggedIn = (state) => {
  return state.persistedReducer.isLoggedIn;
};
export const getUser = (state) => {
  return state.persistedReducer.user;
};
export const getpermUser = (state) => {
  return state.persistedReducer.permUser;
};
export const getinfoUser = (state) => {
  return state.persistedReducer.infoUser;
}

export const mergePermisos = (base, extra) => {
  (extra || []).forEach(emp => {
    const found = base.find(e => e.EMPNITXX === emp.EMPNITXX);
    if (!found) { base.push(emp); return; }
    (emp.GEST0001 || []).forEach(area => {
      const fArea = found.GEST0001?.find(a => a.AREAIDXX === area.AREAIDXX);
      if (!fArea) { (found.GEST0001 = found.GEST0001 || []).push(area); return; }
      (area.GEST0002 || []).forEach(serie => {
        const fSerie = fArea.GEST0002?.find(s => s.SERIEIDX === serie.SERIEIDX);
        if (!fSerie) { (fArea.GEST0002 = fArea.GEST0002 || []).push(serie); return; }
        fSerie.GEST0003 = [...(fSerie.GEST0003 || []), ...(serie.GEST0003 || [])];
      });
    });
  });
  return base;
};

export const hasPermTypes = (perms) =>
  (perms || []).some(emp =>
    (emp.GEST0001 || []).some(area =>
      (area.GEST0002 || []).some(serie => (serie.GEST0003 || []).length > 0)
    )
  );
